import React from 'react'
import sponsors from './img/logos.png'
const Sponsors = () => {
  return (
    <div className='sponsors'>
      <span className='text'>Trusted by over 5000+ paying customers</span>
        <img src={sponsors} alt="" />
    </div>
  )
}

export default Sponsors